import * as angular from "angular";
import {DateRangeTimeFiltersService} from "../commons/services/date-range-time-filters.service";
import {CommonsService} from "../commons/services/commons-service.service";

angular
  .module('bringoz.admin.order-planning-configuration')
  .config(OrderPlanningConfigurationConfig);

/* @ngInject */
function OrderPlanningConfigurationConfig($stateProvider) {
  $stateProvider

    // Orders Planning
    .state('orders-planning', {
      parent: 'bringoz.site',
      url: '/orders-planning',
      abstract: true,
      template: '<ui-view>'
    })

    // Orders Planning Upload - Now using the layout component with tabs
    .state('orders-planning.table', {
      url: '/table?:from&:to&:processStatus&:flowStatuses&:hasProject&:hasRoute',
      controllerAs: 'vm',
      reloadOnSearch: false,
      template: '<custom-order-planning-layout from="vm.from" to="vm.to" process-status="vm.processStatus" flow-statuses="vm.flowStatuses"' +
        ' has-project="vm.hasProject" has-route="vm.hasRoute"></custom-order-planning-layout>',
      controller: function (triBreadcrumbsService, $stateParams, dateRangeTimeFiltersService: DateRangeTimeFiltersService, commonsService: CommonsService, site) {

        if ($stateParams.from && $stateParams.to) {
          this.from = parseInt($stateParams.from)
          this.to = parseInt($stateParams.to);
        } else {
          const dateRangeFilter = dateRangeTimeFiltersService.today();
          this.from = dateRangeFilter.dateStart;
          this.to = dateRangeFilter.dateEnd;
        }

        this.processStatus = commonsService.parseArrayStateParam($stateParams.processStatus) || [];
        this.flowStatuses = commonsService.parseArrayStateParam($stateParams.flowStatuses) || [];
        this.hasProject = !!$stateParams.hasProject ? JSON.parse($stateParams.hasProject) : undefined;
        this.hasRoute = !!$stateParams.hasRoute ? JSON.parse($stateParams.hasRoute) : undefined;

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Custom Order Planning"});
      },
      resolve: {}
    })

}
